import { axiosInstance } from './common';

export const claimSensor = (name, serialNumber) =>
  axiosInstance.post('/sensors', { name, serialNumber }).then((r) => r.data);
